export default __webpack_public_path__ + "static/media/repeat.fc32686f.svg";